import HttpMethodType from 'HttpMethodType';
import SubSystemType from 'SubSystemType';
import BaseServiceRequest from 'BaseServiceRequest';

class GetESDownloadCurrencyImageWebRequest extends BaseServiceRequest {
    constructor(id, osid) {
        super();
        super.addRequestUri("currencyimage.pb");
        super.addRequestParameter("id", id);
        super.addRequestParameter("osid", osid);
    }

    getMethod() {
        return HttpMethodType.GET;
    }

    getSubSystem() {
        return SubSystemType.GRAPH;
    }

    getMessageName() {
        return "";
    }
}

export default GetESDownloadCurrencyImageWebRequest;